import { ACTypeRating } from './ac-type-rating.model';

export interface CrewMember {
  readonly crewMemberId: number | null;
  typeRatings: ACTypeRating[];
  pilotLicense: string;
  pilotLicenseCountryId: number | null;
  ifrTracked: boolean | false;
  evsTracked: boolean | false;
}

export const isCrewMemberSaved = (obj: CrewMember) => {
  return obj.crewMemberId && obj.crewMemberId > 0;
};
